









import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class TextFieldColumnBasic extends Vue {
  @Prop({
    required: false,
    default: 'Label',
  })
  private label!: string;

  @Prop({
    required: false,
    default: '#BDBDBD',
  })
  private labelColor!: string;

  @Prop({
    required: true,
  })
  private value!: string;

  @Prop({
    required: false,
    default: '#333333',
  })
  private valueColor!: string;

  @Prop({
    required: false,
    default: '250px',
  })
  private width!: string;

  @Prop({
    required: false,
    default: '50px',
  })
  private height!: string;

  @Prop({
    required: false,
    default: 'normal',
  })
  private fontWeight!: string;
}
